import React, { PureComponent } from 'react';
import ReactToolTip from "react-tooltip";

class LeagueComponent extends PureComponent {
	static generationIds = 1;
	static defaultProps = {
		showUnranked: false,
		showAlways: false,
		title: null,
		showDivision: false,
	};

	constructor(props) {

		super(props);
		const { onClick, league } = this.props;
		this.onClick = onClick ? onClick.bind(this, league) : null;
		this.uniqueId = `leagueComponent-${LeagueComponent.generationIds++}`;
	}

	render() {
		const { league, showUnranked, showAlways, showDivision, divisionOverride, title } = this.props;
		if(!league) {
			return null;
		}
		if(!league.isRanked() && !showUnranked) {
			return null;
		}
		const previewProps = {};
		if(title) {
			previewProps['data-tip'] = true;
			previewProps['data-for'] = this.uniqueId;
		}
		return (
			<React.Fragment>
				<div
					onClick={this.onClick}
					{...previewProps}
					className={`tier_mini ${league.meetsRankedRequirements() || showAlways ? 'has_league' : 'no_league'} ${league.isUnranked() ? 'tier_ladder_league_unranked' : ''}`}>
					{league.image_url &&
					<img className='mini_tier_icon' src={league.image_url} />
					}
					{!league.image_url && league.isUnranked() &&
					<img className='mini_tier_icon' src={`${siteUrl}/images/smash/tiers/bronze.png`} />
					}
					{showDivision &&
					<span className='division'>
						{divisionOverride || league.division}
					</span>
					}
				</div>
				{!!title &&
				<ReactToolTip
					id={this.uniqueId}
					type='dark'
					effect='solid'
				>
					{title}
				</ReactToolTip>
				}
			</React.Fragment>
		);
	}

}

export { LeagueComponent };
